import { render, staticRenderFns } from "./ResolutionCenterTicket.vue?vue&type=template&id=30aab987&scoped=true&"
import script from "./ResolutionCenterTicket.vue?vue&type=script&lang=js&"
export * from "./ResolutionCenterTicket.vue?vue&type=script&lang=js&"
import style0 from "./ResolutionCenterTicket.vue?vue&type=style&index=0&id=30aab987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aab987",
  null
  
)

export default component.exports